import React, {useState} from 'react';
import {Avatar, Menu, MenuProps, message, Popover, Modal} from 'antd';
import {UserOutlined, ExclamationCircleOutlined} from '@ant-design/icons';
import styles from './AvatarDropdown.module.css';
import {useNavigate} from "react-router-dom";
import {HOME_ROUTE, PROFILE_ROUTE, UPLOAD_ROUTE, ORDERS_ROUTE} from "../../router/routePaths";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../store";
import {logout} from "../../store/slices/userSlice";
import {apiService} from "../../remote/apiService";

const AvatarDropdown: React.FC = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const user = useSelector((state: RootState) => state.user);
    const [selectedKey, setSelectedKey] = useState<string[]>([]);
    const [lastSelectedKey, setLastSelectedKey] = useState<string>('');

    const handleDeleteAccount = async () => {
        Modal.confirm({
            title: '确认注销账号',
            icon: <ExclamationCircleOutlined />,
            content: '注销账号后，您的所有数据将被永久删除且无法恢复。确定要继续吗？',
            okText: '确认注销',
            cancelText: '取消',
            okButtonProps: {
                danger: true
            },
            onOk: async () => {
                try {
                    await apiService.deleteAccount(user.userId);
                    message.success('账号已注销');
                    dispatch(logout());
                    navigate(HOME_ROUTE, { replace: true });
                } catch (error) {
                    // 错误处理已在 apiService 中统一处理
                }
            }
        });
    };

    const handleMenuClick: MenuProps['onClick'] = (e) => {
        setSelectedKey([e.key])

        switch (e.key) {
            case '1':
                setLastSelectedKey(e.key)
                navigate(PROFILE_ROUTE);
                break;
            case '2':
                if (user.isMember) {
                    navigate(UPLOAD_ROUTE);
                } else {
                    setSelectedKey([lastSelectedKey])
                    message.error('开通会员后才能使用该功能');
                }
                break;
            case '3':
                setLastSelectedKey(e.key)
                navigate(ORDERS_ROUTE);
                break;
            case '5':
                handleDeleteAccount();
                break;
            default:
                setLastSelectedKey(e.key)
                dispatch(logout());
                navigate(HOME_ROUTE);
                break;
        }
    };

    const content = (
        <div className={styles.dropdownContent}>
            <div className={styles.nickname}>{user.nickname}</div>
            {user.isMember && (
                <div className={styles.member_expire}>
                    会员到期时间: {user.memberExpire}
                </div>
            )}
            <Menu onClick={handleMenuClick} selectedKeys={selectedKey}>
                <Menu.Item key='1'>个人资料</Menu.Item>
                <Menu.Item key='2'>上传文件</Menu.Item>
                <Menu.Item key='3'>订单中心</Menu.Item>
                <Menu.Item key='4'>退出登录</Menu.Item>
            </Menu>
        </div>
    );

    return (
        <Popover
            content={content}
            trigger="click"
            placement="bottomRight"
        >
            <Avatar 
                icon={<UserOutlined />} 
                className={`${styles.avatar} ${user.isMember ? styles.avatarMember : ''}`}
            />
        </Popover>
    );
};

export default AvatarDropdown;